module.exports = __webpack_public_path__ + "img/arrow-down-square-fill.8d325c56.svg";